var key = "booked:by:checkin:cached:location";

function getCachedLocation(){
  try{
    window.localStorage.setItem('testkey', 'testitem');
    window.localStorage.setItem('testkey', null);
    return {
      get: function () {
        return JSON.parse(window.localStorage.getItem(key));
      },
      set: function (location) {
        return window.localStorage.setItem(key, JSON.stringify(location));
      },
      isEmpty: function() {
        return _.isEmpty(this.get());
      },
      clear: function() {
        window.localStorage.setItem(key, null);
      }
    };
  }
  catch(e){
    var cache = {};
    return {
      get: function () {
        return cache[key];
      },
      set: function (location) {
        cache[key] = location;
      },
      isEmpty: function() {
        return _.isEmpty(this.get());
      },
      clear: function() {
        cache[key] = null;
      }
    };

  }
}

module.exports = getCachedLocation();

// module.exports = {
//   get: function () {
//     return JSON.parse(window.localStorage.getItem(key));
//   },
//   set: function (location) {
//     return window.localStorage.setItem(key, JSON.stringify(location));
//   },
//   isEmpty: function() {
//     return _.isEmpty(this.get());
//   },
//   clear: function() {
//     window.localStorage.setItem(key, null);
//   }
// };